export const EDIT_LOG_DETAILS_MODAL_ID = 'editLogDetails'
